import React, { useEffect, Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import * as XLSX from 'xlsx';
import {
  loadBuildingsList,
  clearBuilding,
  importBuildings,
} from '../../../actions/adminAction';

import BuildingsList from './BuildingsList';

const Buildings = () => {
  const dispatch = useDispatch();
  const buildingsList = useSelector((state) => state.admin.buildingsList);
  const buildingListLoading = useSelector(
    (state) => state.admin.buildingListLoading,
  );
  const dark = useSelector((state) => state.dark.data);

  useEffect(() => {
    if (buildingsList.length === 0 && buildingListLoading) {
      dispatch(loadBuildingsList());
    }
  }, [buildingsList, buildingListLoading]);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  return (
    <Fragment>
      <div className='px-sm-5  px-2 admin-margin w-100 d-flex flex-column my-4 w-100'>
        <div className='mb-2 '>
          <div className='d-flex align-items-center'>
            <h6 className='text-main mb-0'>Admin / Buildings</h6>{' '}
            <div className='rounded-pill text-main admin-list-btn-primary admin-list-count px-2 py-1 align-self-center mx-2 my-2 caption '>
              {buildingsList.length}
            </div>
          </div>
          <div className='d-flex w-100 align-items-center justify-content-end'>
            <div className='d-flex'>
              {/* <div
                className='btn button-parent button-primary d-flex align-items-center px-3 mx-3'
                data-bs-toggle='modal'
                data-bs-target='#Importbuilding'
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  enableBackground='new 0 0 24 24'
                  height='18px'
                  viewBox='0 0 24 24'
                  width='24px'
                  fill='#ffffff'
                  className='button-child'
                >
                  <g>
                    <rect fill='none' height='18' width='18' />
                  </g>
                  <g>
                    <g>
                      <path d='M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z' />
                    </g>
                  </g>
                </svg>
                Import Excel
              </div> */}
              <div
                className='btn button-parent admin-list-btn-secondary d-flex align-items-center px-3 text-main'
                onClick={() => {
                  navigate('/admin/buildings/add');
                  dispatch(clearBuilding());
                }}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  enableBackground='new 0 0 24 24'
                  height='18px'
                  viewBox='0 0 24 24'
                  width='24px'
                  fill='#ffffff'
                  className='button-child'
                >
                  <g>
                    <rect fill='none' height='18' width='18' />
                  </g>
                  <g>
                    <g>
                      <path d='M19,13h-6v6h-2v-6H5v-2h6V5h2v6h6V13z' />
                    </g>
                  </g>
                </svg>
                Add Building
              </div>
            </div>
          </div>
        </div>
        <div className='flex-fill'>
          <BuildingsList
            buildingsList={buildingsList}
            buildingListLoading={buildingListLoading}
          />
        </div>
      </div>
      {/* <div
        className='modal fade'
        id='Importbuilding'
        aria-labelledby='ImportbuildingLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title' id='ImportbuildingLabel'>
                Import Schools
              </h5>
              <button
                type='button'
                className='btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              ></button>
            </div>
            <div className='modal-body'>
              <input
                type='file'
                accept='.xlsx'
                onChange={(e) => {
                  e.preventDefault();
                  var files = e.target.files,
                    f = files[0];
                  var reader = new FileReader();
                  reader.onload = function (e) {
                    var data = e.target.result;
                    let readedData = XLSX.read(data, { type: 'binary' });
                    const wsname = readedData.SheetNames[0];
                    const ws = readedData.Sheets[wsname];

                    
                    const dataParse = XLSX.utils.sheet_to_json(ws, {
                      header: 1,
                    });
                    dataParse.splice(0, 1);
                    console.log(dataParse);
                    let d = [];
                    dataParse.forEach((school) => {
                      if (school.length !== 0) {
                        d.push({
                          SchoolName: school[0],
                        });
                        console.log(d);
                      }
                    });

                    setFile(d);
                  };
                  reader.readAsBinaryString(f);
                }}
              />
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-secondary'
                data-bs-dismiss='modal'
              >
                Cancel
              </button>
              <button
                type='button'
                className='btn button-primary'
                onClick={() => {
                  importSchools({ schools: file });
                }}
                data-bs-dismiss='modal'
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </Fragment>
  );
};

export default Buildings;
